<template>
  <lf-modal
    title=""
    :close="close"
    :navigation
    @navigate="$emit('navigate', $event)"
  >
    <template #header>
      <div class="flex w-full items-center justify-between pb-4">
        <p
          class="overflow-hidden text-2xl font-semibold text-ellipsis whitespace-nowrap text-gray-600"
        >
          {{ item.original_name }}
        </p>
        <icon-base
          class="cursor-pointer"
          :icon="IconDownloadLarge"
          width="40"
          height="40"
          @click="download"
        />
      </div>
    </template>
    <template #content>
      <div class="flex h-70-screen w-full items-center justify-center">
        <show-file v-if="item.file_url" :file-url="item.file_url" />
      </div>
    </template>
  </lf-modal>
</template>

<script setup lang="ts">
import { onKeyStroke } from "@vueuse/core";

import IconDownloadLarge from "@/components/icons/IconDownloadLarge.vue";
import { downloadFile } from "@/helpers/files";

import ShowFile from "@/components/ShowFile.vue";
import LfModal from "@/components/ui/Modal.vue";

import type {
  NavigateDirection,
  NavigationConfig,
} from "@/components/ui/Modal.vue";
import type { IFile } from "@/models/common";

const emit = defineEmits<{
  navigate: [direction: NavigateDirection];
}>();

const { item, close, navigation } = defineProps<{
  item: Partial<IFile>;
  close: () => void;
  navigation?: NavigationConfig;
}>();

const download = () => {
  const { file_url, original_name, isSignedDocument } = item;
  if (!file_url) {
    return;
  }
  return downloadFile(file_url, {}, original_name, !isSignedDocument);
};

const getNavigateShortcut = (direction: NavigateDirection) => () => {
  if (navigation) {
    emit("navigate", direction);
  }
};

onKeyStroke("ArrowLeft", getNavigateShortcut("previous"));
onKeyStroke("ArrowRight", getNavigateShortcut("next"));
</script>
